module.exports = __webpack_public_path__ + "87daeb1288d28bebddf4cfd64a07f642.svg";